import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		login: false,
		upload_type: "",
		musicGenre: "",
	},
	mutations: {
		login: (state) => (state.login = !state.login),
		upload_type: (state, type) => (state.upload_type = type),
		setMusicGenre: (state, genre) => (state.musicGenre = genre),
	},
	actions: {},
	modules: {},
});
